import _ from "lodash";

export default keyPath => _.without(keyPath, "children").map(i => i + 1);
